var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "member-form tongxin-layout"
  }, [_c('h1', {
    staticClass: "title-with-underline"
  }, [_vm._v(" " + _vm._s(_vm.isEditMode ? '家庭成員資料' : '家庭成員資料設定') + " ")]), _c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("姓名")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.name,
      expression: "formData.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "請輸入姓名",
      "maxlength": "50",
      "required": ""
    },
    domProps: {
      "value": _vm.formData.name
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "name", $event.target.value);
      }, _vm.handleNameInput]
    }
  }), _vm.errors.name ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.name))]) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("身分證字號")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.idno,
      expression: "formData.idno"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "請輸入身分證字號",
      "maxlength": "10",
      "required": ""
    },
    domProps: {
      "value": _vm.formData.idno
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "idno", $event.target.value);
      }
    }
  }), _vm.errors.idno ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.idno))]) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("出生年月日")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.birthday,
      expression: "formData.birthday"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": _vm.formData.birthday
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "birthday", $event.target.value);
      }
    }
  }), _vm.errors.birthday ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.birthday))]) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("與本人關係")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.relationship,
      expression: "formData.relationship"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "請輸入與本人關係",
      "maxlength": "20",
      "required": ""
    },
    domProps: {
      "value": _vm.formData.relationship
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "relationship", $event.target.value);
      }
    }
  }), _vm.errors.relationship ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.relationship))]) : _vm._e()]), !_vm.isEditMode ? _c('div', {
    staticClass: "reminder-green"
  }, [_vm._v(" 我們將透過上述資料提供您相關服務，請務必填寫真實資料，勿冒用他人資料以避免相關法律問題。"), _c('br'), _vm._v(" 若需接收家人就診相關通知，需攜帶病人雙證件與代理人雙證件，至診所辦理。 ")]) : _vm._e(), _vm.isEditMode ? _c('div', {
    staticClass: "reminder-green"
  }, [_vm._v(" 授權 王大明先生（或 xxx 女士）已授權您新增本項修改紀錄，並代替本人處理相關事務。 ")]) : _vm._e(), _c('button', {
    staticClass: "btn btn-primary btn-block mb-3",
    attrs: {
      "type": "submit",
      "disabled": _vm.isLoading
    }
  }, [_vm._v(" " + _vm._s(_vm.isEditMode ? '儲存更新' : '新增') + " ")]), _vm.isEditMode ? _c('button', {
    staticClass: "btn btn-outline-danger btn-block mb-3",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.handleDelete
    }
  }, [_vm._v(" 刪除 ")]) : _vm._e()]), _c('div', {
    staticStyle: {
      "padding-bottom": "96px"
    }
  }), _c('div', {
    staticClass: "fixed-footer-navigation"
  }, [_c('TongxinNavigation', {
    attrs: {
      "backButtonIsVisible": true,
      "nextButtonIsVisible": false
    },
    on: {
      "back": _vm.goBack
    }
  })], 1), _vm.isLoading ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }